const ERROR_CONST = {
  404: {
    title: 'Page not found',
    description: 'We couldn’t find what you’re looking for.',
    suggestion: 'Try going back to the homepage.'
  },
  502: {
    title: 'Server hiccup',
    description: 'Something went wrong on our end.',
    suggestion: 'Please refresh or try again later.'
  }
};

export default ERROR_CONST;
